import { css } from 'astroturf';
import React, { useState } from 'react';
import Link from '../link';

const styles = css`
  .mainblock {
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;

    & h3 {
      padding-left: 0.75rem;
      font-size: 0.8rem;
      text-transform: uppercase;
      color: var(--fill);
    }

    & button {
      border: none;
      background: none;
      text-align: left;
      font: inherit;
      color: inherit;
    }

    & a,
    button {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.5rem;
      border-radius: 0.5rem;
      background: none;
      padding: 0.25rem 0.5rem;
      color: rgba(10, 21, 48, 0.667);
      transition:
        color 0.25s ease-in-out 0s,
        background 0.25s ease-in-out 0s;
      font-weight: normal;

      & svg {
        margin: 0;
        flex: 0 0 20px;
        stroke: rgb(0, 124, 165);
      }
      &:hover,
      &:focus {
        color: var(--fill);
        background: rgba(16, 125, 181, 0.1);
      }
    }
  }
`;

const copyToClipboard = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

function BrandKit() {
  const [copiedIcon, setIconCopied] = useState(false);
  const [copiedLogo, setLogoCopied] = useState(false);

  const copyIcon = (e) => {
    e.preventDefault();
    copyToClipboard(iconSVG);
    setIconCopied(true);
    setTimeout(() => setIconCopied(false), 1000);
  };
  const copyLogo = (e) => {
    e.preventDefault();
    copyToClipboard(logoSVG);
    setLogoCopied(true);
    setTimeout(() => setLogoCopied(false), 1000);
  };

  return (
    <div className={styles.mainblock}>
      <h3>Brand kit</h3>
      <button type="button" onClick={copyIcon}>
        <PolypaneIcon /> {copiedIcon ? '🎉 Copied!' : 'Copy icon as SVG'}
      </button>
      <button type="button" onClick={copyLogo}>
        <LogoIcon /> {copiedLogo ? '🎉 Copied!' : 'Copy logo as SVG'}
      </button>
      <Link to="/docs/brand-guidelines/">
        <LighthouseIcon /> Brand guidelines
      </Link>
      <Link to="/">
        <HomeIcon /> Homepage
      </Link>
    </div>
  );
}

export default BrandKit;

const PolypaneIcon = ({
  className,
  width = 20,
  height = 20,
  strokeWidth = '1',
  strokeLinejoin = 'round',
  strokeLinecap = 'round',
  color = 'currentcolor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-brand-polypane"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
  >
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M 21,12 H 15 M 15,4 V 14 H 9 M 9,4 V 16 H 4" />
  </svg>
);

const HomeIcon = ({
  className,
  width = 20,
  height = 20,
  strokeWidth = '1',
  strokeLinejoin = 'round',
  strokeLinecap = 'round',
  color = 'currentcolor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-home"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
  >
    <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
  </svg>
);

const LighthouseIcon = ({
  className,
  width = 20,
  height = 20,
  strokeWidth = '1',
  strokeLinejoin = 'round',
  strokeLinecap = 'round',
  color = 'currentcolor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-book-2"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
  >
    <path d="M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"></path>
    <path d="M19 16h-12a2 2 0 0 0 -2 2"></path>
    <path d="M9 8h6"></path>
  </svg>
);

const LogoIcon = ({
  className,
  width = 20,
  height = 20,
  strokeWidth = '1',
  strokeLinejoin = 'round',
  strokeLinecap = 'round',
  color = 'currentcolor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-abc"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
  >
    <path d="M3 7v-2h13v2"></path>
    <path d="M10 5v14"></path>
    <path d="M12 19h-4"></path>
    <path d="M15 13v-1h6v1"></path>
    <path d="M18 12v7"></path>
    <path d="M17 19h2"></path>
  </svg>
);

const iconSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">
<defs>
  <linearGradient id="b">
    <stop offset="0" stop-color="#fff" stop-opacity=".618"/>
    <stop offset="1" stop-color="#fff" stop-opacity="0"/>
  </linearGradient>
  <linearGradient id="a">
    <stop offset="0" stop-color="#393756"/>
    <stop offset=".2475" stop-color="#393756"/>
    <stop offset=".2584" stop-color="#306985"/>
    <stop offset=".5859" stop-color="#306985"/>
    <stop offset=".5993" stop-color="#3d84a8"/>
    <stop offset="1" stop-color="#3d84a8"/>
  </linearGradient>
  <linearGradient xlink:href="#c" id="f" x1="871.6517" x2="260.3639" y1="-241.2697" y2="-808.6147" gradientUnits="userSpaceOnUse"/>
  <linearGradient id="c">
    <stop offset="0" stop-color="#208dc5"/>
    <stop offset=".0442" stop-color="#208dc5"/>
    <stop offset="1" stop-color="#16c58d"/>
  </linearGradient>
  <linearGradient xlink:href="#d" id="g" x1="578.1192" x2="624.0668" y1="-523.3238" y2="-157.7552" gradientUnits="userSpaceOnUse"/>
  <linearGradient id="d">
    <stop offset="0" stop-color="#fff"/>
    <stop offset="1" stop-color="#fff" stop-opacity=".851"/>
  </linearGradient>
  <linearGradient xlink:href="#e" id="k" x1="44.8321" x2="970.7216" y1="562.5881" y2="558.7756" gradientTransform="translate(0 .9727)" gradientUnits="userSpaceOnUse"/>
  <linearGradient id="e">
    <stop offset="0" stop-color="#208dc5"/>
    <stop offset=".3065" stop-color="#208dc5"/>
    <stop offset=".3175" stop-color="#1baaa8"/>
    <stop offset=".6499" stop-color="#1ba9a9"/>
    <stop offset=".6632" stop-color="#16c58d"/>
    <stop offset="1" stop-color="#16c58d"/>
  </linearGradient>
  <filter id="h" width="1.0848" height="1.0939" x="-.0424" y="-.0424" color-interpolation-filters="sRGB">
    <feFlood flood-color="#306985" flood-opacity=".3843" result="flood"/>
    <feComposite in="flood" in2="SourceGraphic" operator="in" result="composite1"/>
    <feGaussianBlur in="composite1" result="blur" stdDeviation="10"/>
    <feOffset dy="6" result="offset"/>
    <feComposite in="SourceGraphic" in2="offset" result="fbSourceGraphic"/>
    <feColorMatrix in="fbSourceGraphic" result="fbSourceGraphicAlpha" values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"/>
    <feFlood flood-color="#306985" flood-opacity=".3843" result="flood"/>
    <feComposite in="flood" in2="fbSourceGraphic" operator="out" result="composite1"/>
    <feGaussianBlur in="composite1" result="blur" stdDeviation="3.2"/>
    <feOffset dy=".8021" result="offset"/>
    <feComposite in="offset" in2="fbSourceGraphic" operator="atop" result="composite2"/>
  </filter>
  <filter id="i" width=".969" height=".9291" x=".0208" y=".0397" color-interpolation-filters="sRGB">
    <feFlood flood-color="#306985" flood-opacity=".3843" result="flood"/>
    <feComposite in="flood" in2="SourceGraphic" operator="out" result="composite1"/>
    <feGaussianBlur in="composite1" result="blur" stdDeviation="6.4"/>
    <feOffset dy="7.2192" result="offset"/>
    <feComposite in="offset" in2="SourceGraphic" operator="atop" result="composite2"/>
  </filter>
  <clipPath id="j" clipPathUnits="userSpaceOnUse">
    <circle cx="512" cy="540.3622" r="425.3753" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="20.678"/>
  </clipPath>
</defs>
<g transform="matrix(1.13 0 0 1.13 -73.5012 1085.7948)">
  <circle cx="518.127" cy="-507.7678" r="373.4785" fill="url(#f)" transform="matrix(1.1913 0 0 1.1913 -99.0929 97.1117)"/>
  <circle cx="518.127" cy="-507.7678" r="373.4785" fill="url(#g)" filter="url(#h)" transform="translate(-52.8495 51.7929) scale(1.102)"/>
  <g filter="url(#i)" transform="matrix(-1 0 0 1 1030.493 -1048.984)">
    <path fill="url(#k)" d="M684.5716 59.2729h279.6218v962.1785H684.5716Zm-314.2222 0h262.8775v718.1239H370.3494Zm-320.2571 0h268.9123V613.342H50.0923Z" clip-path="url(#j)" transform="matrix(.878 0 0 .878 62.8312 65.9254)"/>
  </g>
</g>
</svg>
`;

const logoSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 5620 1200">
<defs>
  <linearGradient id="c">
    <stop offset="0" stop-color="#4ca2cd" stop-opacity=".9862"/>
    <stop offset="1" stop-color="#67b26f"/>
  </linearGradient>
  <linearGradient id="b">
    <stop offset="0" stop-color="#fff" stop-opacity=".618"/>
    <stop offset="1" stop-color="#fff" stop-opacity="0"/>
  </linearGradient>
  <linearGradient id="a">
    <stop offset="0" stop-color="#393756"/>
    <stop offset=".2475" stop-color="#393756"/>
    <stop offset=".2584" stop-color="#306985"/>
    <stop offset=".5859" stop-color="#306985"/>
    <stop offset=".5993" stop-color="#3d84a8"/>
    <stop offset="1" stop-color="#3d84a8"/>
  </linearGradient>
  <linearGradient xlink:href="#c" id="g" x1="1341.5917" x2="5454.1133" y1="199.5932" y2="1054.3728" gradientTransform="translate(-164.8813 180.339)" gradientUnits="userSpaceOnUse"/>
  <linearGradient xlink:href="#d" id="j" x1="871.6517" x2="260.3639" y1="-241.2697" y2="-808.6147" gradientUnits="userSpaceOnUse"/>
  <linearGradient id="d">
    <stop offset="0" stop-color="#208dc5"/>
    <stop offset=".0442" stop-color="#208dc5"/>
    <stop offset="1" stop-color="#16c58d"/>
  </linearGradient>
  <linearGradient xlink:href="#e" id="l" x1="578.1192" x2="624.0668" y1="-523.3238" y2="-157.7552" gradientUnits="userSpaceOnUse"/>
  <linearGradient id="e">
    <stop offset="0" stop-color="#fff"/>
    <stop offset="1" stop-color="#fff" stop-opacity=".851"/>
  </linearGradient>
  <linearGradient xlink:href="#f" id="o" x1="44.8321" x2="970.7216" y1="562.5881" y2="558.7756" gradientTransform="translate(0 .9727)" gradientUnits="userSpaceOnUse"/>
  <linearGradient id="f">
    <stop offset="0" stop-color="#208dc5"/>
    <stop offset=".3065" stop-color="#208dc5"/>
    <stop offset=".3175" stop-color="#1baaa8"/>
    <stop offset=".6499" stop-color="#1ba9a9"/>
    <stop offset=".6632" stop-color="#16c58d"/>
    <stop offset="1" stop-color="#16c58d"/>
  </linearGradient>
  <linearGradient xlink:href="#c" id="i" x1="1165.3719" x2="5388.6982" y1="546.8926" y2="546.8926" gradientTransform="translate(0 265.45)" gradientUnits="userSpaceOnUse"/>
  <filter id="k" width="1.0848" height="1.0939" x="-.0424" y="-.0424" color-interpolation-filters="sRGB">
    <feFlood flood-color="#306985" flood-opacity=".3843" result="flood"/>
    <feComposite in="flood" in2="SourceGraphic" operator="in" result="composite1"/>
    <feGaussianBlur in="composite1" result="blur" stdDeviation="10"/>
    <feOffset dy="6" result="offset"/>
    <feComposite in="SourceGraphic" in2="offset" result="fbSourceGraphic"/>
    <feColorMatrix in="fbSourceGraphic" result="fbSourceGraphicAlpha" values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"/>
    <feFlood flood-color="#306985" flood-opacity=".3843" result="flood"/>
    <feComposite in="flood" in2="fbSourceGraphic" operator="out" result="composite1"/>
    <feGaussianBlur in="composite1" result="blur" stdDeviation="3.2"/>
    <feOffset dy=".8021" result="offset"/>
    <feComposite in="offset" in2="fbSourceGraphic" operator="atop" result="composite2"/>
  </filter>
  <filter id="m" width=".969" height=".9291" x=".0208" y=".0397" color-interpolation-filters="sRGB">
    <feFlood flood-color="#306985" flood-opacity=".3843" result="flood"/>
    <feComposite in="flood" in2="SourceGraphic" operator="out" result="composite1"/>
    <feGaussianBlur in="composite1" result="blur" stdDeviation="6.4"/>
    <feOffset dy="7.2192" result="offset"/>
    <feComposite in="offset" in2="SourceGraphic" operator="atop" result="composite2"/>
  </filter>
  <clipPath id="n" clipPathUnits="userSpaceOnUse">
    <circle cx="512" cy="540.3622" r="425.3753" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="20.678"/>
  </clipPath>
  <path id="h" d="M1317.3385 614.4556h2694.5239v316.2553H1317.3385z"/>
</defs>
<g fill="url(#g)" stroke-linecap="square" stroke-linejoin="bevel" stroke-width="175.06" aria-label="Polypane" font-family="Inter UI" font-size="277.907" font-weight="500" paint-order="fill markers stroke" style="line-height:70%;-inkscape-font-specification:&quot;Inter UI, Medium&quot;;font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:end" text-anchor="end" transform="translate(107.8392 -155.9736)">
  <g fill="url(#i)" aria-label="Polypane" font-family="Inter V" font-size="933.333" font-weight="400" letter-spacing="0" style="line-height:1.25;-inkscape-font-specification:&quot;Inter V, @wght=700&quot;;font-feature-settings:&quot;salt&quot;;font-variation-settings:&quot;wght&quot;700" word-spacing="0">
    <path d="M1165.3718 377.495v678.7872h143.5136V836.206h120.6426c52.1464 0 96.561-9.6105 133.2403-28.834 36.9001-19.2234 65.0711-46.0713 84.5156-80.541 19.4444-34.4696 29.168-74.2427 29.168-119.3184 0-45.0756-9.6125-84.8487-28.836-119.3183-19.0025-34.6906-46.6221-61.7568-82.8594-81.2012-36.2373-19.6654-80.0984-29.498-131.582-29.498h-267.8027zm143.5136 117.3282h96.7793c27.8409 0 50.8209 4.7507 68.9395 14.252 18.1186 9.2802 31.5972 22.4275 40.4355 39.4414 9.0594 16.7929 13.5899 36.4582 13.5899 58.996 0 22.317-4.5305 42.0933-13.5899 59.3282-8.8383 17.0139-22.3169 30.3813-40.4355 40.1035-17.8977 9.5012-40.6555 14.252-68.2754 14.252h-97.4434V494.8231zM1988.7995 540.5634c-51.4835 0-96.0072 11.0467-133.5703 33.1426-37.3422 21.875-66.1776 52.589-86.5059 92.1406-20.3282 39.3308-30.4921 85.2906-30.4921 137.879 0 52.1463 10.1639 97.9951 30.4921 137.5468 20.3283 39.3308 49.1637 70.0447 86.5059 92.1406 37.5631 21.875 82.0868 32.8125 133.5703 32.8125 51.4836 0 95.8962-10.9375 133.2383-32.8125 37.5631-22.0959 66.5077-52.8098 86.8359-92.1406 20.3283-39.5517 30.4942-85.4005 30.4942-137.5469 0-52.5883-10.1659-98.5481-30.4942-137.8789-20.3282-39.5517-49.2728-70.2656-86.8359-92.1406-37.3421-22.096-81.7547-33.1426-133.2383-33.1426zm.6621 107.7168c23.4217 0 42.976 6.7403 58.6641 20.2188 15.6881 13.4785 27.5103 31.8168 35.4648 55.0176 8.1756 23.2007 12.2637 49.6062 12.2637 79.2148 0 29.6086-4.0881 56.0122-12.2637 79.2129-7.9545 23.2007-19.7767 41.541-35.4648 55.0195-15.6881 13.2576-35.2424 19.8867-58.6641 19.8867-23.6426 0-43.5281-6.6291-59.6582-19.8867-15.909-13.4785-27.9514-31.8188-36.1269-55.0195-7.9546-23.2007-11.9317-49.6043-11.9317-79.2129 0-29.6086 3.9771-56.0141 11.9317-79.2148 8.1755-23.2008 20.2179-41.5391 36.1269-55.0176 16.1301-13.4785 36.0156-20.2188 59.6582-20.2188zM2331.5065 377.495V922.712c.221 48.39 13.2572 83.8547 39.1094 106.3925 25.8523 22.317 65.8474 32.4809 119.9824 30.4922 17.6768-.6628 31.7067-2.099 42.0918-4.3086 10.6061-2.4305 19.556-4.7513 26.8477-6.9609l-22.5391-102.746c-2.6515 1.1047-5.9661 1.9894-9.9433 2.6523-3.9773.6628-9.5016 1.1052-16.5723 1.3261-13.6994 0-23.4211-3.5367-29.166-10.6074-5.524-7.2917-8.3963-19.0028-8.6172-35.1328V377.495h-141.1934zM2572.1315 547.1923l182.6231 523.6739-8.2852 21.5429c-6.1868 15.9091-14.2521 27.1779-24.1953 33.8067-9.7222 6.6288-21.3242 9.7232-34.8027 9.2812-13.2575-.4419-28.1722-3.205-44.7442-8.2871l-31.8183 105.3985c10.1641 4.1982 22.9801 7.6219 38.4473 10.2734 15.6881 2.8725 32.4811 4.3086 50.3789 4.3086 34.9115 0 64.7408-5.6334 89.4882-16.9024 24.7475-11.0479 45.1865-26.8472 61.3164-47.3964 16.351-20.3283 29.2781-44.1909 38.7793-71.5899l197.8692-564.1094h-149.4785l-106.3926 373.8633h-5.3027l-105.3985-373.8633h-148.4844zM3449.78 540.5634c-28.5038 0-52.3664 4.8599-71.5899 14.582-19.0025 9.5013-34.4705 21.4326-46.4023 35.795-11.7109 14.1414-20.6588 28.0622-26.8457 41.7617h-6.2969v-85.5098h-139.2051v699.9981h141.1934V974.749h4.3086c6.4079 14.1414 15.6871 28.1714 27.8398 42.0918 12.1528 13.6995 27.7319 25.0793 46.7344 34.1386 19.2235 9.0594 42.5346 13.5879 69.9336 13.5879 38.6678 0 73.5791-9.9418 104.7344-29.8281 31.3761-20.1073 56.1234-49.6053 74.2422-88.4941 18.3395-39.1098 27.5097-87.0592 27.5097-143.8457 0-58.3333-9.3903-106.8341-28.1718-145.502-18.7816-38.8888-43.8602-67.9445-75.2364-87.168-31.3762-19.4444-65.6269-29.166-102.748-29.166zm-45.0742 112.3575c23.2007 0 42.755 6.2979 58.664 18.8925 15.9091 12.5947 27.9515 30.0503 36.127 52.3672 8.1754 22.317 12.2636 48.169 12.2636 77.5567 0 29.6085-4.1992 55.792-12.5957 78.5507-8.1754 22.5379-20.2179 40.2137-36.1269 53.0293-15.9091 12.5947-35.3523 18.8926-58.332 18.8926-22.7589 0-42.0929-6.1868-58.002-18.5605-15.909-12.5947-28.0625-30.1614-36.459-52.6993-8.3964-22.5378-12.5937-48.9414-12.5937-79.2128 0-30.2715 4.1973-56.566 12.5937-78.8828 8.3965-22.317 20.4389-39.5524 36.127-51.7051 15.9091-12.1528 35.3542-18.2285 58.334-18.2285zM3936.9948 540.5634c-37.3421 0-71.7019 9.7216-103.0781 29.166-31.1552 19.2235-56.1227 48.2792-74.9043 87.168-18.7815 38.6679-28.1719 87.1687-28.1719 145.502 0 56.7865 9.0591 104.7359 27.1778 143.8457 18.3396 38.8888 43.0869 68.3868 74.2421 88.4941 31.3763 19.8863 66.3986 29.8281 105.0665 29.8281 27.3989 0 50.599-4.5285 69.6015-13.5879 19.2235-9.0593 34.8006-20.4391 46.7324-34.1386 12.1528-13.9204 21.5451-27.9504 28.1739-42.0918h5.9648v81.5332h139.2051V547.1923h-140.8613v85.5098h-4.3086c-6.1869-13.6995-15.246-27.6203-27.1778-41.7617-11.7108-14.3624-27.1789-26.2937-46.4023-35.795-19.0025-9.7221-42.756-14.582-71.2598-14.582zm45.0762 112.3575c22.7588 0 42.0929 6.0757 58.0019 18.2285 15.9092 12.1527 28.0626 29.3882 36.459 51.705 8.3965 22.317 12.5938 48.6114 12.5938 78.8829 0 30.2714-4.3083 56.675-12.9258 79.2129-8.3965 22.5378-20.5499 40.1045-36.459 52.6992-15.6881 12.3737-34.9111 18.5605-57.6699 18.5605-23.2008 0-42.755-6.2979-58.6641-18.8926-15.6881-12.8156-27.7305-30.4914-36.1269-53.0293-8.1755-22.7588-12.2637-48.9422-12.2637-78.5507 0-29.3876 4.0882-55.2398 12.2637-77.5567 8.1755-22.3169 20.2179-39.7725 36.1269-52.3672 15.9091-12.5947 35.4633-18.8925 58.6641-18.8925zM4636.3308 540.5634c-37.7841 0-69.9322 8.7278-96.4473 26.1836-26.5151 17.2349-45.4088 40.6552-56.6777 70.2637h-5.9649v-89.8184h-134.5644v509.0899h141.1933V761.9638c.221-21.875 4.3092-40.5465 12.2637-56.0136 8.1755-15.6882 19.4443-27.6195 33.8066-35.795 14.5834-8.1755 31.3764-12.2636 50.3789-12.2636 28.2828 0 50.4891 8.8388 66.6192 26.5156 16.13 17.4558 24.0842 41.7607 23.8633 72.916v298.959h141.1933V732.1337c0-39.5517-7.2917-73.5782-21.875-102.082-14.5833-28.7247-35.0223-50.8219-61.3164-66.289-26.2942-15.4672-57.1191-23.1993-92.4726-23.1993zM5149.3991 540.5634c-49.9368 0-93.4667 11.0467-130.5879 33.1426-36.9001 22.096-65.5135 52.921-85.8418 92.4727-20.3283 39.5517-30.4922 85.5115-30.4922 137.8789 0 53.693 10.1639 100.2044 30.4922 139.5351 20.3283 39.1098 49.2729 69.3814 86.836 90.8145 37.7841 21.2121 82.8611 31.8183 135.2285 31.8183 41.9822 0 78.9921-6.4089 111.0312-19.2246 32.2601-13.0366 58.5546-31.1547 78.8828-54.3554 20.5492-23.4217 34.1388-50.821 40.7676-82.1973l-130.5879-8.6172c-4.861 12.8157-11.9306 23.6421-21.2109 32.4805-9.2803 8.8383-20.44 15.4675-33.4766 19.8867-13.0366 4.4192-27.3978 6.629-43.0859 6.629-23.6426 0-44.0816-4.971-61.3164-14.9142-17.2349-9.9431-30.6042-24.0842-40.1055-42.4238-9.2802-18.3396-13.9199-40.1055-13.9199-65.295v-.33h346.6855V799.085c0-43.308-6.0757-81.0915-18.2285-113.3515-12.1528-32.481-29.168-59.438-51.0429-80.8711-21.6541-21.433-47.0639-37.4526-76.2305-48.0586-28.9456-10.827-60.211-16.2403-93.7969-16.2403zm2.3203 105.3965c20.5492 0 38.5563 4.5305 54.0235 13.5899 15.6881 8.8383 27.9527 21.101 36.791 36.789 8.8384 15.6881 13.2578 33.6972 13.2578 54.0254H5042.196c.8539-18.273 5.5102-34.9702 14.0684-50.0488 9.2802-16.572 22.0962-29.7173 38.4472-39.4395 16.572-9.9431 35.5748-14.916 57.0078-14.916z"/>
  </g>
</g>
<g transform="translate(-27.6 -109.604)">
  <circle cx="518.127" cy="-507.7678" r="373.4785" fill="url(#j)" filter="url(#k)" transform="matrix(1.3462 0 0 1.3462 -66.5673 1393.1383)"/>
  <circle cx="518.127" cy="-507.7678" r="373.4785" fill="url(#l)" filter="url(#k)" transform="matrix(1.2453 0 0 1.2453 -14.3108 1341.9265)"/>
  <g filter="url(#m)" transform="matrix(-1.13 0 0 1.13 1209.9033 98.0112)">
    <path fill="url(#o)" d="M684.5716 59.2729h279.6218v962.1785H684.5716Zm-314.2222 0h262.8775v718.1239H370.3494Zm-320.2571 0h268.9123V613.342H50.0923Z" clip-path="url(#n)" transform="matrix(.878 0 0 .878 62.8312 65.9254)"/>
  </g>
</g>
</svg>
`;
